<template>
<div >

	<Navbar></Navbar>
	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class=" container" v-if="!loading">	
			
			
			<div class="card mt-2">
				<div class="card-body">

					<div class="page-header">
						<ol class="breadcrumb">
							<li class="breadcrumb-item">GENERAL</li>
							<router-link tag="li" to="/clients" class="breadcrumb-item active">Clientes</router-link>
						</ol>
						<div class="title">
							<h1>{{client.name}}</h1>
						</div>
						<div class="cta">
							<b-dropdown text="Acciones" class="m-md-2" right variant="light">
								<router-link tag="b-dropdown-item" :to="`/clients/${client.id}/edit`">Editar</router-link>
								<router-link tag="b-dropdown-item" :to="`/clients/${client.id}/fares`">Tarifas</router-link>
							</b-dropdown>
						</div>
					</div>

					<div class="row">
						<div class="col-12 col-md-3 pt-4">
							<strong class="mt-4">Datos de cliente </strong>
							<p >
								Razón social: {{client.business_name}} <br>
								Email: {{client.email}} <br>
								Teléfono: {{client.phone.national}} <br>
							</p>
						</div>
						<div class="col-12 col-md-9">

							<div class="boxes" v-if="data.totals">
								<router-link tag="div" :to="`/cars?status=PRE_ADMITTED&client_id=${client.id}`" class="box">
									<div class="number">{{data.totals.carsPreAdmited}}</div>
									<div class="label">Pre admitidos</div>
								</router-link>
								<router-link tag="div" :to="`/cars?status=IN_CUSTOMS_DEPOSIT&client_id=${client.id}`" class="box">
									<div class="number">{{data.totals.carsInCustomsDeposit}}</div>
									<div class="label">En depósito fiscal</div>
								</router-link>
								<router-link tag="div" :to="`/cars?status=CUSTOMS_DISPATCH_PENDING&client_id=${client.id}`" class="box">
									<div class="number">{{data.totals.carsCustomsDispatchPending}}</div>
									<div class="label">Pendientes de despacho</div>
								</router-link>
								<router-link tag="div" :to="`/cars?status=IN_NATIONAL_DEPOSIT&client_id=${client.id}`" class="box">
									<div class="number">{{data.totals.carsInNationalDeposit}}</div>
									<div class="label">En depósito nacional</div>
								</router-link>
								<router-link tag="div" :to="`/cars?status=PRE_DELIVERY_PENDING&client_id=${client.id}`" class="box">
									<div class="number">{{data.totals.carsPreDeliveryPending}}</div>
									<div class="label">Pendientes de pre entrega</div>
								</router-link>
								<router-link tag="div" :to="`/cars?status=PRE_DELIVERY_DONE&client_id=${client.id}`" class="box">
									<div class="number">{{data.totals.carsPreDeliveryDone}}</div>
									<div class="label">Pre entegas realizadas</div>
								</router-link>
								<router-link tag="div" :to="`/cars?status=DELIVERY_SCHEDULED&client_id=${client.id}`" class="box">
									<div class="number">{{data.totals.carsDeliveryScheduled}}</div>
									<div class="label">Entregas programadas</div>
								</router-link>
							</div>
						</div>
					</div>

					<!-- <div class="row">
						<div class="col mb-4">
							<b-tabs content-class="">

								<b-tab title="Daños" active>
									<div class="p-4">
										<h4>Daños</h4>
										<table class="table" v-if="data.damages.length>0">
											<tr class="table-head">
												<td></td>
												<td>Chasis</td>
												<td>Vehículo</td>
												<td>Cliente</td>
											</tr>
											
											<router-link tag="tr" :to="`/cars/${item.car.id}`" v-for="item of data.damages" :key="item.id" >
												<td>
													<div class="tc">
														<span class="text-primary">{{item.typeText}}</span>
														<span >{{item.description}}</span>
													</div>
												</td>
												<td>{{item.car.chassis_number}}</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.car.brand.title}}</span>
														<span >{{item.car.model}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.car.client.name}}</span>
														<span >{{item.car.client.business_name}}</span>
													</div>
												</td>
											</router-link>
										</table>
										<div class="alert alert-light text-center" v-else>No se han encontrado daños</div>
									</div>
								</b-tab>

								<b-tab title="Cargos">
									<div class="p-4">
										<h4>Cargos</h4>
										<table class="table" v-if="data.charges.length>0">
											<tr class="table-head">
												<td></td>
												<td>Chasis</td>
												<td>Vehículo</td>
												<td>Cliente</td>
											</tr>
											<router-link tag="tr" :to="`/cars/${item.car.id}`" v-for="item of data.charges" :key="item.id" >
												<td>
													<div class="tc">
														<span class="text-primary">{{item.description}}</span>
														<span >U$S {{item.price}}</span>
													</div>
												</td>
												<td>{{item.car.chassis_number}}</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.car.brand.title}}</span>
														<span >{{item.car.model}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.client.name}}</span>
														<span >{{item.client.business_name}}</span>
													</div>
												</td>
											</router-link>
										</table>
										<div class="alert alert-light text-center" v-else>No se han encontrado cargos</div>
									</div>
								</b-tab>
								
								<b-tab title="Entregas programadas">
									<div class="p-4">
										<h4>Entregas programadas para esta semana</h4>
										<table class="table" v-if="data.carsToDelivery.length>0">
											<tr class="table-head">
												<td>Chasis</td>
												<td>Vehículo</td>
												<td>Cliente</td>
												<td>Estado</td>
											</tr>
											
											<tr v-for="item of data.carsToDelivery" :key="item.id" @click="openPreview(item.id)">
												<td>{{item.chassis_number}}</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.brand.title}}</span>
														<span >{{item.model}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.client.name}}</span>
														<span >{{item.client.business_name}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span><div class="car-status-point" :class="item.status"></div>{{item.statusText}}</span>
														<span v-if="item.delivery_scheduled_at" style="margin-left: 15px;">{{item.delivery_scheduled_at | moment("DD-MM-YYYY")}}</span>
													</div>
												</td>
											</tr>
										</table>
										<div class="alert alert-light text-center" v-else>No se han encontrado entregas programadas</div>
									</div>
								</b-tab>
							</b-tabs>
						</div>
					</div> -->
						
					<div class="overflow-hidden mt-4">
						<b-button @click="$router.go(-1)" type="button" class="pull-left" size="sm" variant="light">Volver</b-button>
					</div>
					

				</div>
			</div>
		</div>
	</div>
	
</div>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Loader from '@/components/Loader'
import Navbar from '@/components/Navbar'

export default {
	name: 'ClientDetail',
	mixins:[mixins],
	components:{
		Loader,
		Navbar,
	},
	data () {
		return {
			title: '',
			client: {},
			data: {},
			loading: true,
		}
	},
	beforeMount(){
		if( this.$route.params.id > 0 ){
			this.load(this.$route.params.id)
		}else{
			this.$router.go(-1)
		}
	},
	methods: {
		load(id){
			this.$apollo.query({
				query: gql`query  ($client_id: ID){
					userDashboard (client_id: $client_id) {
						carsToDelivery{
							id
							chassis_number
							model
							brand{
								title
							}
							client{
								name
								business_name
							}
							status
							statusText
							delivery_scheduled_at
						}
						
						totals{
							carsPreAdmited
							carsInCustomsDeposit
							carsCustomsDispatchPending
							carsInNationalDeposit
							carsPreDeliveryPending
							carsPreDeliveryDone
							carsDeliveryScheduled
						}
					},
					client (id: $client_id) {
		 				id
		 				name
		 				business_name
		 				email
		 				phone{
		 					countryCode
		 					national
		 					international
		 					type
		 					validated
		 				}
		 			}
				}`,
				variables: {
					client_id: id,
				},
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
				console.log(data)
				this.data = data.data.userDashboard;
				this.client = data.data.client;
				this.loading = false
				
			});
		},
		// load(id){
		// 	this.$apollo.query({
		// 		query: gql`query ($id: ID!) {
		// 			client (id: $id) {
		// 				id
		// 				name
		// 				business_name
		// 				email
		// 				phone{
		// 					countryCode
		// 					national
		// 					international
		// 					type
		// 					validated
		// 				}
		// 			}
		// 		}`,
		// 		variables: {
		// 			id
		// 		},
		// 	})
		// 	.then((data) => {
		// 		this.client = data.data.client;
		// 		this.loading = false
		// 	});
		// },
	}
}


</script>

<style scoped lang="scss">

.boxes{
	display: flex;
	width: 100%;
	flex-wrap: wrap;

	.box{
		margin: 2px;
		padding: 16px 8px;
		
		background-color: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		flex-grow: 1;
		cursor: pointer;
		transition: all .3s;

		.number{
			font-size: 1.6rem;
			font-weight: 600;;
		}
		.label{
			font-size: .7rem;
			font-weight: 400;
			text-align: center;
		}
	}
	.box:hover{
		background-color: #d7e7f5;
	}
}



</style>